import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './NavList.module.scss';

type NavListProps = {
  className?: string;
  nested?: boolean;
  children: ReactNode;
};

export const NavList: FC<NavListProps> = (props) => {
  const { className, nested, children } = props;

  return (
    <div
      className={cn(styles.list, nested && styles.listNested, className)}
      role="list"
    >
      {children}
    </div>
  );
};
